import { useEffect, useState } from "react"
import {
    getArticuloById,
    postArticulo,
    patchArticulo,
} from "../../services/ArticulosServices"
import { postArtColor } from "../../services/ArticulosColoresServices";
import { postCombo } from "../../services/ArticulosCombosServices";
import { postArtMedida } from "../../services/ArticulosMedidasServices";
import { postArtModelo } from "../../services/ArticulosModelosServices";
import { postArtPresentacion } from "../../services/ArticulosPresentacionesServices";
import { postArtTalle } from "../../services/ArticulosTallesServices";
import { postArtTemporada } from "../../services/ArticulosTemporadasServices";
import { ArticulosFormContext } from "./ArticulosContext"
import { useNavigate, useParams } from 'react-router-dom';

export const ArticulosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    // Definir estados para las variables temporales
    const [caracteristicasData, setCaracteristicasData] = useState({
        color: [],
        medida: [],
        modelo: [],
        combo: [],
        presentacion: [],
        talle: [],
        temporada: []
    });
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getArticuloByIdData(id)
    }, [id])

    const getArticuloByIdData = async (id) => {
        let res = await getArticuloById(id)
        if (res) setReport(res)
        return res
    }

    const postArticuloData = async (body) => {
        let res = null;
        try {
            if (caracteristicasData.combo.length > 0) {
                const Articulos_combo = caracteristicasData.combo.map(({ ac_id_hijo, ac_cantidad }) => ({
                    "id": ac_id_hijo,  // Renombrar `ac_id_hijo` a `id`
                    "cantidad": parseFloat(ac_cantidad) // Mantener `cantidad`
                }));
                // Serializar el array `Articulos_combo` a JSON y agregarlo a FormData
                body.append('art_id', JSON.stringify(Articulos_combo));

                res = await postCombo(body);
               
            }
            else {
                res = await postArticulo(body); 
            }

            if (res) {
                const articleId = res.data.id;

                // Revisión de las características y grabación de datos adicionales
                if (caracteristicasData.color.length > 0) {
                    await grabarColores(articleId, caracteristicasData.color);
                } 
                if (caracteristicasData.medida.length > 0) {
                    await grabarMedidas(articleId, caracteristicasData.medida);
                } 
                if (caracteristicasData.modelo.length > 0) {
                    await grabarModelos(articleId, caracteristicasData.modelo);
                } 
                if (caracteristicasData.presentacion.length > 0) {
                    await grabarPresentaciones(articleId, caracteristicasData.presentacion);
                } 
                if (caracteristicasData.talle.length > 0) {
                    await grabarTalles(articleId, caracteristicasData.talle);
                } 
                if (caracteristicasData.temporada.length > 0) {
                    await grabarTemporadas(articleId, caracteristicasData.temporada);
                } 
                navigate("/articulos");
            }
        } catch (error) {
            console.error("Error al guardar el artículo:", error);
        }
    };

    const grabarColores = async (articleId, colores) => {
        // Recorrer el array de colores y ejecutar postColor para cada uno
        const promises = colores.map(async (color) => {
            // Ajustar el body del color según lo que se necesita para postColor
            delete color.id;
            delete color.art_Id;
            delete color.col_descripcion;
            const colorBody = {
                art_Id: articleId,  // Asociar el color al ID del artículo recién creado
                ...color  // Si el objeto color ya tiene las propiedades necesarias
            };
            try {
                const colorRes = await postArtColor(colorBody);
                return colorRes;  // Devolver el resultado de cada postColor
            } catch (error) {
                console.error("Error al guardar el color:", error);
                throw error;  // Lanzar el error para manejarlo si es necesario
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const grabarMedidas = async (articleId, medidas) => {
        const promises = medidas.map(async (medida) => {

            delete medida.id;
            delete medida.art_Id;
            delete medida.med_descripcion;
            const medidaBody = {
                art_Id: articleId,
                ...medida
            };
            try {
                const medidaRes = await postArtMedida(medidaBody);
                return medidaRes;
            } catch (error) {
                console.error("Error al guardar el medida:", error);
                throw error;
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const grabarModelos = async (articleId, modelos) => {
        const promises = modelos.map(async (modelos) => {

            delete modelos.id;
            delete modelos.art_Id;
            delete modelos.mod_descripcion;
            const modeloBody = {
                art_Id: articleId,
                ...modelos
            };
            try {
                const modeloRes = await postArtModelo(modeloBody);
                return modeloRes;  // Devolver el resultado de cada postModelo
            } catch (error) {
                console.error("Error al guardar el modelo:", error);
                throw error;  // Lanzar el error para manejarlo si es necesario
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const grabarPresentaciones = async (articleId, presentaciones) => {
        const promises = presentaciones.map(async (presentacion) => {
            delete presentacion.id;
            delete presentacion.art_Id;
            delete presentacion.pre_descripcion;
            const presentacionBody = {
                art_Id: articleId,
                ...presentacion
            };
            try {
                const presentacionRes = await postArtPresentacion(presentacionBody);
                return presentacionRes;
            } catch (error) {
                console.error("Error al guardar el presentacion:", error);
                throw error;
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const grabarTalles = async (articleId, talles) => {
        const promises = talles.map(async (talle) => {
            // Ajustar el body del color según lo que se necesita para postColor
            delete talle.id;
            delete talle.art_Id;
            delete talle.tal_descripcion;
            const talleBody = {
                art_Id: articleId,
                ...talle
            };
            try {
                const talleRes = await postArtTalle(talleBody);
                return talleRes;  // Devolver el resultado de cada postColor
            } catch (error) {
                console.error("Error al guardar el talle:", error);
                throw error;  // Lanzar el error para manejarlo si es necesario
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const grabarTemporadas = async (articleId, temporadas) => {
        const promises = temporadas.map(async (temporada) => {
            // Ajustar el body del color según lo que se necesita para postColor
            delete temporada.id;
            delete temporada.art_Id;
            delete temporadas.tem_descripcion;
            const temporadaBody = {
                art_Id: articleId,
                ...temporada
            };
            try {
                const temporadaRes = await postArtTemporada(temporadaBody);
                return temporadaRes;  // Devolver el resultado de cada postColor
            } catch (error) {
                console.error("Error al guardar el temporada:", error);
                throw error;  // Lanzar el error para manejarlo si es necesario
            }
        });

        // Esperar a que todas las promesas se resuelvan
        await Promise.all(promises);

    };

    const patchArticuloData = async (id, body) => {
        const res = await patchArticulo(id, body)
        if (res) navigate("/articulos");
    }

    const addItemToArray = (type, item) => {
        setCaracteristicasData(prevState => ({
            ...prevState,
            [type]: [...prevState[type], item]
        }));
    };

    const viewItemFromArray =  (type, id) => {
        // Convertimos ambos a string para asegurarnos de que la comparación sea consistente
        const item =caracteristicasData.type.find((item) => String(item.id) === String(id));

        return item || null; // Si no encuentra el elemento, devuelve null
    };
 


    const updateItemFromArray = (type, id, cantidad) => {
        setCaracteristicasData(prevState => ({
            ...prevState,
            [type]: prevState[type].map(item =>
                item.id === id
                    ? { ...item, ac_cantidad: cantidad }
                    : item
            )
        }));
    };

    const deleteItemFromArray = (type, id) => {
        setCaracteristicasData(prevState => ({
            ...prevState,
            [type]: prevState[type].filter(item => item.id !== id)
        }));
    };

    return <ArticulosFormContext.Provider value={{
        report,

        postArticuloData,
        patchArticuloData,

        getArticuloByIdData,

        caracteristicasData,
        addItemToArray,
        viewItemFromArray,
        updateItemFromArray,
        deleteItemFromArray
    }} >
        {children}
    </ArticulosFormContext.Provider>
}